



































































































































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import selectTree from '../selectTree/index.vue'
@Component({
    components: {selectTree}
})
export default class extends Vue {
    @Prop({type: String}) title: String;
    @Prop({type: String, default: 'form'}) formref: String;
    @Prop({type: String, default: '50%'}) width: String;
    @Prop({type: String, default: '120px'}) labelWidth: String;
    @Prop({type: String, default: 'top'}) labelPosition: String;
    @Prop({type: Boolean, default: false}) disabled: Boolean;
    @Prop({type: Boolean, default: false}) value: Boolean;
    @Prop({type: Object}) formData: Object;
    @Prop({type: Array}) formItem: Array<any>;

    cancel() {
        (this.$refs[(this.formref as any)] as any).resetFields();
        this.$emit('input', false);
    }

    save() {
        (this.$refs[(this.formref as any)] as any).validate(valid => {
            if (valid) {
                console.log(this.formData)
                this.$emit("submit", this.formData);
            } else {
                return false;
            }
        });
    }
}
